import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 5E3C88DE-A208-471A-9096-7C7868CC957C
 * name octagon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/octagon.svg
 * tags
 * - Shape 
 * - Transportation + Road 
 */
export const OctagonIcon = createSvgIcon(<><path d="M15.73,3H8.27L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27" /></>, 'OctagonIcon');
export default OctagonIcon